import envVar from '../config/envVars';
import httpDelete from './httpClient/httpDelete';
import httpGet from './httpClient/httpGet';
import httpPost from './httpClient/httpPost';

const getSchoolOptionalConcessionMaster = async (school: string) => {
  return httpGet(
    `${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/schools/${school}/optional-concessions-master`
  );
};

export interface OptionalConcessionMasterRequest {
  id?: string;
  school: string;
  concessionName: string;
  applicableOn: string[];
  type: string;
  concession: {
    amount?: number | null;
    percentage?: number | null;
  };
}

const upsertSchoolOptionalConcessionMaster = async (
  school: string,
  payload: OptionalConcessionMasterRequest
) => {
  return httpPost(
    `${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/schools/${school}/optional-concessions-master`,
    payload
  );
};

const deleteSchoolOptionalConcessionMaster = async (id: string) => {
  return httpDelete(
    `${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/schools/${id}/optional-concessions-master`
  );
};

const optionalConcession = {
  getSchoolOptionalConcessionMaster,
  deleteSchoolOptionalConcessionMaster,
  upsertSchoolOptionalConcessionMaster
};

export default optionalConcession;
